import { browsePanneaux, getPanneauxPoints } from '@/api/panneauxNumeriques';
import { filtrer, donneFiltresPourEnfant } from '@/services/general/listeFilter';
import { FILTRE_DYNAMIQUE_VIDE } from '@/components/creationOpportunite/configuration/filtresConf';
import { CLASS_NIVEAU_DISPONIBILITE } from '@/components/creationOpportunite/configuration/DisponibiliteConf';
import { SANS_TYPE_VENTE } from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import { ZOOM_DEFAULT_LC, RAYON_DEFAULT, PANNEAUX_FROM_VENTES_NUMERIQUES, ISOCHRONE_DEFAULT, TYPE_LAYER_EMPTY } from '@/configuration/carteConf';
import { panneauNumeriqueExtensionInitializer } from '@/services/panier/extensionInitializer';
import gestionErreur from '@/services/general/gestionErreur';
import fromTypeToMarkers from '@/services/catalogue/fromTypeToMarkers';
import GetListeElementUniqueParPropriete from '@/services/general/listeFilterDynamique';
import customArraySort from '@/services/general/customArraySort';
import { iconColorGetter, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import * as typesPanier from '@/store/creationOpportunite/panier-mutation-type';
import moment from 'moment/moment';
import * as types from './venteNumerique-mutation-type';
import * as allTypes from '../mutation-type';

function initialState() {
  return {
    criterePlanning: {},
    panneaux: [],
    panneauxWithFilter: [],
    address: null,
    rayon: RAYON_DEFAULT,
    isochrone: ISOCHRONE_DEFAULT,
    typeLayerGeoMarketing: TYPE_LAYER_EMPTY,
    dateStart: moment().add(1, 'w').startOf('week').toDate(),
    dateEnd: moment(moment().add(1, 'w').startOf('week').toDate()).add(2, 'w').subtract(1, 'd').toDate(),
    showPanneaux: false,
    affichageCercle: false,
    zoomCarto: ZOOM_DEFAULT_LC,
    filtres: {},
    filtresDynamiques: [],
    selectedFiltreDynamique: FILTRE_DYNAMIQUE_VIDE,
    filterChanged: true,
    markers: [],
    selectedMarker: '',
    typeVente: SANS_TYPE_VENTE,
    showPanneauxSelectionne: false,
    pointsAddress: [],
  };
}

const state = initialState();

const namespaced = true;

const mutations = {
  [allTypes.RESET_STATE]() {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [allTypes.RESET_NOT_PERSISTED](state) {
    const s = initialState();
    Object.keys(state).forEach(key => {
      state[key] = s[key];
    });
  },
  [types.SET_PANNEAUX](state, panneaux) {
    state.panneaux = panneaux;
  },
  [types.SET_CRITERE_PLANNING](state, critere) {
    state.criterePlanning = critere;
  },
  [types.SET_PANNEAUX_WITH_FILTER](state, panneaux) {
    state.panneauxWithFilter = panneaux;
  },
  [types.SET_SHOW_PANNEAUX](state, showPanneaux) {
    state.showPanneaux = showPanneaux;
  },
  [types.SET_DATE_START](state, dateStart) {
    state.dateStart = dateStart;
  },
  [types.SET_DATE_END](state, dateEnd) {
    state.dateEnd = dateEnd;
  },
  [types.SET_FILTER_ADDRESS](state, address) {
    state.address = address;
  },
  [types.SET_FILTER_RAYON](state, rayon) {
    state.rayon = rayon;
  },
  [types.SET_ISOCHRONE](state, isochrone) {
    state.isochrone = isochrone;
  },
  [types.SET_TYPE_LAYER_GEO_MARKETING](state, typeLayerGeoMarketing) {
    state.typeLayerGeoMarketing = typeLayerGeoMarketing;
  },
  [types.SET_AFFICHAGE_CERCLE](state, affichageCercle) {
    state.affichageCercle = affichageCercle;
  },
  [types.SET_ZOOM_CARTO](state, zoomCarto) {
    state.zoomCarto = zoomCarto;
  },
  [types.ADD_FILTER_PROPERTY](state, { property, valueProperty }) {
    state.filtres[property] = valueProperty;
  },
  [types.REMOVE_FILTER_PROPERTY](state, property) {
    state.filtres[property] = {};
    state.filtresDynamiques.forEach((filtreDynamique) => {
      if (filtreDynamique.id === property) {
        state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtreDynamique), 1);
      }
    });
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.REMOVE_FILTER](state) {
    state.filtres = {};
    state.filtresDynamiques = [];
    state.selectedFiltreDynamique = FILTRE_DYNAMIQUE_VIDE;
  },
  [types.ADD_FILTER_DYNAMIQUE](state, value) {
    const filtre = state.filtresDynamiques.find((el) => { return el.id === value.id; });
    if (filtre) {
      state.filtresDynamiques.splice(state.filtresDynamiques.indexOf(filtre), 1, value);
    } else {
      state.filtresDynamiques.unshift(value);
    }
  },
  [types.SELECT_FILTRE_DYNAMIQUE](state, filtre) {
    state.selectedFiltreDynamique = filtre;
  },
  [types.TRIE_PANNEAUX](state) {
    state.panneauxWithFilter.sort(customArraySort(['ville', 'code']));
  },
  [types.SET_FILTER_CHANGED](state) {
    state.filterChanged = !state.filterChanged;
  },
  [types.SET_MARKER](state, markers) {
    state.markers = markers;
  },
  [types.SET_SELECTED_MARKER](state, marker) {
    state.selectedMarker = marker;
  },
  [types.SET_TYPE_VENTE](state, typeVente) {
    state.typeVente = typeVente;
  },
  [types.SET_PANNEAU_SELECTED](state, payload) {
    const panneau = state.panneaux.find((el) => { return el.num === payload.panNum; });
    if (panneau) {
      panneau.selected = payload.value;
    }
  },
  [types.SET_SHOW_PANNEAUX_SELECTIONNE](state, showPanneauxSelectionne) {
    state.showPanneauxSelectionne = showPanneauxSelectionne;
  },
  [types.SET_POINTS_ADDRESS](state, pointsAddress) {
    state.pointsAddress = pointsAddress;
  },
};

const specAffichage = {
  day: {
    widescreen: {
      unit: 'days', size: 32, startOf: false,
    },
    tablet: {
      unit: 'days', size: 14, startOf: false,
    },
  },
  week: {
    widescreen: {
      unit: 'weeks', size: 10, startOf: 'isoWeek',
    },
    tablet: {
      unit: 'weeks', size: 5, startOf: 'isoWeek',
    },
  },
};
const actions = {
  recuperationPanneaux: async ({ getters, commit, dispatch, rootGetters }, payload) => {
    if (payload.valid) {
      try {
        const dateStart = moment(getters.dateStart).clone().format('YYYYMMDD');
        const dateEnd = moment(getters.dateEnd).clone().format('YYYYMMDD');
        commit(types.SET_SHOW_PANNEAUX, false);
        const responseAllPoint = await getPanneauxPoints(getters.pointsAddress, getters.rayon,
          dateStart, dateEnd, getters.proposableLc, payload.codeFace);
        let response;
        let tabAll = [];
        if (getters.address !== null) {
          response = await browsePanneaux(getters.address,
            getters.rayon, dateStart, dateEnd,
            true, payload.codeFace);
          response.data.forEach(el => {
            el.pointAddress = {
              icon: iconColorGetter('#000000', TAILLE_ICON_PETIT),
              coordonnees: getters.address,
            };
          });
          tabAll = response.data.concat(responseAllPoint.map(el => el.data).flat());
        } else {
          response = await browsePanneaux({ lat: 0.00, lng: 0.00 },
            getters.rayon, dateStart, dateEnd,
            true, payload.codeFace);
          if (response.data !== undefined) {
            response.data.forEach(el => {
              el.pointAddress = {
                icon: iconColorGetter('#000000', TAILLE_ICON_PETIT),
                coordonnees: { lat: el.latitude, lng: el.longitude },
              };
            });
            tabAll = response.data.concat(responseAllPoint.map(el => el.data).flat());
            if (tabAll.length > 0) {
              commit('SET_FILTER_ADDRESS', { lat: tabAll[0].latitude, lng: tabAll[0].longitude });
            }
          }
        }

        const alreadySelected = rootGetters['panier/panneauxNumeriquesPanier'];
        tabAll.forEach((el) => { el.selected = false; });
        alreadySelected.forEach((selectedItem) => {
          const reseau = tabAll.find((el) => {
            return el.num === selectedItem.num;
          });
          if (reseau) {
            reseau.selected = true;
          } else {
            selectedItem.selected = true;
            tabAll.push(selectedItem);
          }
        });
        tabAll.forEach((panneau) => {
          panneau.codeFaces = '';
          if (panneau.faces && panneau.faces.length > 0) {
            panneau.codeFaces = panneau.faces.map((el) => el.facCode).reduce((accumulator, currentValue) => accumulator + ', ' + currentValue);
          }
        });
        commit(types.SET_PANNEAUX, tabAll);
        commit(types.SET_PANNEAUX_WITH_FILTER, getters.panneaux);
        dispatch('gestionDisponibilite');
        dispatch('gestionFiltres');
        commit(types.TRIE_PANNEAUX, getters.panneauxWithFilter);
        const afficherAzimut = rootGetters['user/afficherAzimut'];
        const markers = fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES,
          getters.panneauxWithFilter, afficherAzimut);
        commit(types.SET_MARKER, markers);

        dispatch('reloadFiltreDynamique');
        commit(types.SET_SHOW_PANNEAUX, true);
        dispatch('changementDateDebutPlanning',
          {
            debut: moment(getters.dateStart),
            granularity: 'day',
          },
        );
      } catch (e) {
        gestionErreur('Erreur lors de la récupération des panneaux Numériques', e);
        throw (e.code);
      }
    } else {
      commit(types.SET_PANNEAUX, '');
      commit(types.SET_MARKER, '');
      commit(types.SET_SHOW_PANNEAUX, false);
    }
  },
  changementDateDebutPlanning: ({ getters, commit }, payload) => {
    let newStartDate = payload.debut;
    if (!newStartDate.isValid()) {
      newStartDate = moment();
    }

    let breakpoint = 'tablet';
    if (window.innerWidth >= 1216) { // Magic constant coming from bulma
      breakpoint = 'widescreen';
    }
    if (specAffichage[payload.granularity][breakpoint].startOf) {
      newStartDate.startOf(specAffichage[payload.granularity][breakpoint].startOf);
    }
    if (newStartDate === getters.criterePlanning.dateStart &&
        breakpoint === getters.criterePlanning.breakpoint &&
        payload.granularity === getters.criterePlanning.granularity) {
      return;
    }
    const critere = {};
    critere.size = specAffichage[payload.granularity][breakpoint].size;
    critere.unit = specAffichage[payload.granularity][breakpoint].unit;
    // Détermination durée initiale
    const dureeBase = moment.duration(moment(getters.dateEnd).diff(
      moment(getters.dateStart)));
    const newEndDate = newStartDate.clone().add(dureeBase.asDays(), 'days');
    const newDuration = newEndDate.diff(newStartDate, 'days') + 1;
    critere.granularity = payload.granularity;
    critere.breakpoint = breakpoint;
    critere.selectedDateStart = moment(getters.dateStart);
    critere.selectedDateEnd = moment(getters.dateEnd);
    critere.months = payload.nombreMois;
    critere.dateStart = newStartDate;
    critere.dateEnd = newEndDate;
    critere.days = newDuration > 31 ? 31 : newDuration;
    commit(types.SET_CRITERE_PLANNING, critere);
    commit(types.SET_DATE_START, critere.dateStart.toDate());
    commit(types.SET_DATE_END, critere.dateEnd.toDate());
  },
  gestionDisponibilite: ({ getters, commit }) => {
    const value = getters.panneaux.map((panneau) => {
      panneau.dispoClass = CLASS_NIVEAU_DISPONIBILITE[panneau.niveauDisponibilite];
      return panneau;
    });
    commit(types.SET_PANNEAUX, value);
  },
  gestionFiltres: ({ getters, rootGetters, commit }) => {
    commit(types.SET_FILTER_CHANGED);
    const panneauxWithFilter = filtrer(getters.panneaux, getters.filtres);
    const azimut = rootGetters['user/afficherAzimut'];
    panneauxWithFilter.forEach((el) => {
      const filtreDispo = donneFiltresPourEnfant(getters.filtres);
      el.faces = filtrer(el.faces, filtreDispo);
    });
    commit(types.SET_PANNEAUX_WITH_FILTER, panneauxWithFilter);
    commit(types.SET_MARKER, fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES,
      getters.panneauxWithFilter, azimut));
  },
  reloadFiltreDynamique: ({ getters, commit, dispatch }) => {
    getters.filtresDynamiques.forEach((filtre) => {
      const prop = filtre;
      const filtrePropChecked = filtre.valeur.filter((el) => { return el.checked === true; });
      prop.valeur = (GetListeElementUniqueParPropriete(getters.panneaux,
        filtre.id));
      prop.valeur.forEach((valeur) => {
        if (filtrePropChecked.find((el) => { return el.name === valeur.name; })) {
          valeur.checked = true;
        }
      });
      filtrePropChecked.forEach((valeur) => {
        if (!prop.valeur.find((el) => {
          return el.name === valeur.name;
        })) {
          prop.valeur.push(valeur);
        }
      });
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
      if (filtrePropChecked.length > 0) {
        dispatch('gestionFiltres');
      }
    });
  },
  ajoutFiltresDynamiques: ({ getters, commit }, payload) => {
    if (!getters.filtresDynamiques.find((el) => { return el.id === payload.valueProperty.id; })) {
      const prop = payload.valueProperty;
      prop.valeur = (GetListeElementUniqueParPropriete(getters.panneaux,
        payload.valueProperty.id));
      commit(types.ADD_FILTER_DYNAMIQUE, prop);
    }
  },
  gestionPanier: async ({ getters, dispatch }, payload) => {
    if (getters.typeVente === SANS_TYPE_VENTE) {
      return;
    }
    const panneauNumerique = getters.panneaux.find((el) => { return el.num === payload.panNum; });
    if (!panneauNumerique) {
      return;
    }

    dispatch('ajoutAuPanier', { panneau: panneauNumerique, tarification: payload.tarification, periode: payload.periode });
    dispatch('updateMarkerPanneau');
  },
  ajoutAuPanier: async ({ commit, dispatch, rootGetters }, payload) => {
    const panneauAAjouter = await panneauNumeriqueExtensionInitializer(
      Object.assign({}, payload.panneau),
      payload.tarification,
      payload.periode);
    panneauAAjouter.selected = false;
    const adresse = rootGetters['panier/adressePanier'];
    let adresseVenteNumerique;
    if (adresse) {
      adresseVenteNumerique = {
        lat: adresse.coordonnees.lat,
        lng: adresse.coordonnees.lng,
        nom: 'adresseVenteNumerique',
      };
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_PANNEAU_NUMERIQUE, panneauAAjouter, { root: true });
    commit('panier/' + typesPanier.ADD_ADRESSES_PRODUITS, adresseVenteNumerique, { root: true });
    dispatch('panier/genererMarkerPanneauxNumerique', null, { root: true });
  },
  ajoutPeriodeAuPanier: ({ commit }, payload) => {
    commit('panier/' + typesPanier.REMOVE_PRODUIT_TYPE_PANNEAU_NUMERIQUE, payload.produit, { root: true });
    payload.produit.extensionOpportunite.periode += `- ${payload.periode} `;
    if (payload.produit.extensionOpportunite.quantite) {
      payload.produit.extensionOpportunite.quantite =
        parseInt(payload.produit.extensionOpportunite.quantite, 10) + 1;
    }
    commit('panier/' + typesPanier.ADD_PRODUIT_TYPE_PANNEAU_NUMERIQUE, payload.produit, { root: true });
  },
  updateMarkerPanneau: ({ getters, rootGetters, commit }) => {
    const azimut = rootGetters['user/afficherAzimut'];
    commit(types.SET_MARKER,
      fromTypeToMarkers(PANNEAUX_FROM_VENTES_NUMERIQUES, getters.panneauxWithFilter, azimut));
  },
};

const getters = {
  criterePlanning: (state) => {
    return state.criterePlanning;
  },
  panneaux: (state) => {
    return state.panneaux;
  },
  panneauxWithFilter: (state) => {
    return state.panneauxWithFilter;
  },
  address: (state) => {
    return state.address;
  },
  rayon: (state) => {
    return state.rayon;
  },
  isochrone: (state) => {
    return state.isochrone;
  },
  typeLayerGeoMarketing: (state) => {
    return state.typeLayerGeoMarketing;
  },
  dateStart: (state) => {
    return state.dateStart;
  },
  dateEnd: (state) => {
    return state.dateEnd;
  },
  showPanneaux: (state) => {
    return state.showPanneaux;
  },
  affichageCercle: (state) => {
    return state.affichageCercle;
  },
  zoomCarto: (state) => {
    return state.zoomCarto;
  },
  disponibiliteAvailability: (state) => {
    return state.dateEnd && state.dateStart && state.address;
  },
  filtres: (state) => {
    return state.filtres;
  },
  filtresDynamiques: (state) => {
    return state.filtresDynamiques;
  },
  filtresDynamiquesSpe: (state) => (id) => {
    return state.filtresDynamiques.find((el) => { return el.id === id; });
  },
  selectedFiltreDynamique: (state) => {
    return state.selectedFiltreDynamique;
  },
  filterChanged: (state) => {
    return state.filterChanged;
  },
  markers: (state) => {
    return state.markers;
  },
  selectedMarker: (state) => {
    return state.selectedMarker;
  },
  typeVente: (state) => {
    return state.typeVente;
  },
  showPanneauxSelectionne: (state) => {
    return state.showPanneauxSelectionne;
  },
  pointsAddress: (state) => {
    return state.pointsAddress.filter(el => el.coordonnees);
  },
};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/creationOpportunite/venteNumerique.js